<template>
    <v-row justify="center">
        <role-credentials v-model="dialog_role" :client_id="client_id" :product_id="product_id"></role-credentials>
        <v-dialog v-model="dialog" persistent max-width="850px" scrollable :fullscreen="$vuetify.breakpoint.name == `xs`">
            <v-card :loading="loading" outlined>
                <v-card-title class="primary" dense>
                    <span class="headline text-uppercase white--text">{{ title }}</span>
                </v-card-title>
                <v-card-text>
                    <v-container v-show="hasRole(['ADMIN', 'client-detail:create'])">
                        <v-subheader class="title">Credenciais</v-subheader>
                        <v-form ref="form" v-model="valid" :lazy-validation="lazy">
                            <v-row>
                                <v-col cols="12" sm="4">
                                    <v-select
                                        v-model="credential.product_id"
                                        :items="products_filtred"
                                        :rules="[required]"
                                        item-text="name"
                                        item-value="id"
                                        label="Produto"
                                        placeholder="Selecione o produto"
                                        :disabled="isEdit"
                                        outlined
                                    ></v-select>
                                </v-col>
                                <v-col cols="12" sm="8">
                                    <v-text-field 
                                        v-model="credential.client_id" 
                                        label="Client ID" 
                                        placeholder="Gerar Client ID" 
                                        :rules="[required]"
                                        append-icon="mdi-settings-outline"
                                        outlined 
                                        readonly
                                        :disabled="isEdit"
                                        @click:append="generate_client_id"
                                        :loading="loading_client_id"
                                    >
                                    </v-text-field>
                                </v-col>
                            </v-row>
                            <v-row>
                                <v-col cols="12">
                                    <v-text-field 
                                        :value="client_secret" 
                                        label="Client Secret" 
                                        placeholder="Gerar Client Secret" 
                                        :rules="[required]"
                                        :append-icon="isEdit ? `mdi-refresh` : `mdi-settings-outline`"
                                        outlined 
                                        readonly
                                        @click:append="generate_client_secret"
                                        :loading="loading_client_secret"
                                        :type="!showPassword ? `password`: `text`"
                                        :key="index_client_secret"
                                    >
                                    </v-text-field>
                                </v-col>
                            </v-row>
                            <v-row>
                                <v-col cols="12" sm="5">
                                    <v-combobox
                                        v-model="escopo"
                                        :items="escopos"
                                        :rules="[required]"
                                        label="Escopo"
                                        placeholder="Informe o escopo"
                                        multiple
                                        chips
                                        outlined
                                    ></v-combobox>
                                </v-col>
                                <v-col cols="12" sm="7">
                                    <v-combobox
                                        v-model="authorized_grant_types"
                                        :items="grant_types"
                                        label="Grant Types"
                                        placeholder="Ex: authorization_code,password,refresh_token,implicit,client_credentials" 
                                        :rules="[required]"
                                        multiple
                                        chips
                                        outlined
                                    ></v-combobox>
                                </v-col>
                            </v-row>
                            <v-expansion-panels accordion>
                                <v-expansion-panel>
                                    <v-expansion-panel-header class="font-weight-bold">Configurações Avançadas</v-expansion-panel-header>
                                    <v-expansion-panel-content>
                                        <v-row>
                                            <v-col cols="12">
                                                <v-text-field 
                                                    v-model="credential.web_server_redirect_uri" 
                                                    label="Redirect Uri" 
                                                    placeholder="Informe a uri de redirecionamento" 
                                                    outlined 
                                                >
                                                </v-text-field>
                                            </v-col>
                                        </v-row>
                                        <v-row>
                                            <v-col cols="12" sm="6">
                                                <v-text-field 
                                                    v-model="credential.access_token_validity" 
                                                    label="Validade token de acesso" 
                                                    placeholder="Informe a validade do token de acesso" 
                                                    type="number"
                                                    outlined 
                                                >
                                                </v-text-field>
                                            </v-col>
                                            <v-col cols="12" sm="6">
                                                <v-text-field 
                                                    v-model="credential.refresh_token_validity" 
                                                    label="Validade do Refresh Token" 
                                                    placeholder="Informe a validade do refresh token" 
                                                    type="number"
                                                    outlined 
                                                >
                                                </v-text-field>
                                            </v-col>
                                        </v-row>
                                        <v-row>
                                            <v-col cols="12" sm="6">
                                                <v-text-field 
                                                    v-model="credential.resource_ids" 
                                                    label="Resource IDS" 
                                                    placeholder="Informe resource ids" 
                                                    outlined 
                                                >
                                                </v-text-field>
                                            </v-col>
                                            <v-col cols="12" sm="6">
                                                <v-text-field 
                                                    v-model="credential.authorities" 
                                                    label="Authorities" 
                                                    placeholder="Informe o Authorities" 
                                                    outlined 
                                                >
                                                </v-text-field>
                                            </v-col>
                                        </v-row>
                                        <v-row>
                                            <v-col cols="12" sm="6">
                                                <v-text-field 
                                                    v-model="credential.additional_information" 
                                                    label="Informações adicionais" 
                                                    placeholder="Informe as informações adicionais" 
                                                    outlined 
                                                >
                                                </v-text-field>
                                            </v-col>
                                            <v-col cols="12" sm="6">
                                                <v-text-field 
                                                    v-model="credential.autoapprove" 
                                                    label="Auto Aprovar" 
                                                    placeholder="Informe Auto Aprovar" 
                                                    outlined 
                                                >
                                                </v-text-field>
                                            </v-col>
                                        </v-row>
                                    </v-expansion-panel-content>
                                </v-expansion-panel>
                            </v-expansion-panels>
                        </v-form>
                        <v-row>
                            <v-spacer></v-spacer>
                            <v-btn v-show="isEdit" color="primary" @click="cancel" outlined>
                                <v-icon left>mdi-close-circle-outline</v-icon>CANCELAR
                            </v-btn>
                            <v-btn color="primary" @click="add" :disabled="!hasRole(['ADMIN', 'client-detail:create'])" depressed>
                                <v-icon left>{{ icon_btn_add }}</v-icon>{{ label_btn_add }}
                            </v-btn>
                        </v-row>
                        <v-divider></v-divider>
                    </v-container>
                    <v-row>
                        <v-col cols="12">
                            <v-data-table
                                :headers="headers"
                                :items="items"
                                :loading="loading"
                            >
                                <template v-slot:item.product_name="{ item }">
                                    {{ get_product_name({ id: item.product_id }) }}
                                </template>
                                <template v-slot:item.actions="{ item }">
                                    <v-tooltip bottom>
                                        <template v-slot:activator="{ on }">
                                            <v-btn class="ma-2" icon :disabled="item.loading || item.is_new || !hasRole(['ADMIN', 'role-clientdetail:read'])" v-on="on" @click="roles(item)">
                                                <v-icon color="warning">mdi-apps</v-icon>
                                            </v-btn>
                                        </template>
                                        <span style="color:#FFF">Perfil</span>
                                    </v-tooltip>
                                    <v-tooltip bottom>
                                        <template v-slot:activator="{ on }">
                                            <v-btn class="ma-2" icon :disabled="item.loading || !hasRole(['ADMIN', 'client-detail:save'])" v-on="on" @click="update(item)">
                                                <v-icon color="primary">mdi-pencil</v-icon>
                                            </v-btn>
                                        </template>
                                        <span style="color:#FFF">Editar</span>
                                    </v-tooltip>
                                    <v-tooltip bottom>
                                        <template v-slot:activator="{ on }">
                                            <v-btn class="ma-2" icon :disabled="item.loading || !hasRole(['ADMIN', 'client-detail:delete'])" v-on="on" @click="remove(item)">
                                                <v-icon color="error">mdi-delete</v-icon>
                                            </v-btn>
                                        </template>
                                        <span style="color:#FFF">Remover</span>
                                    </v-tooltip>
                                </template>
                            </v-data-table>
                        </v-col>
                    </v-row>
                </v-card-text>
                <v-divider/>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn color="primary" @click="close" outlined>
                        <v-icon left>mdi-close-circle-outline</v-icon>FECHAR
                    </v-btn>
                    <v-btn color="primary" @click="save" :disabled="!hasRole(['ADMIN', 'client-detail:save'])">
                        <v-icon left>mdi-content-save-outline</v-icon>SALVAR
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
    </v-row>
</template>

<script>
    import { mapState, mapGetters } from 'vuex'
    import { required } from '@/utils/roles.js'
    import  cryptoRandomString from 'crypto-random-string'
    import RoleCredentials from './RoleCredentials.vue'
    
    export default {
        data: () => ({
            loading: null,
            loading_client_id: null,
            loading_client_secret: null,
            is_new_client_secret: null,
            valid: null,
            lazy: false,
            isEdit: null,
            headers: [
                { sortable: true, text: 'Produto', value: 'product_name' },
                { sortable: true, text: 'Client ID', value: 'client_id' },
                { sortable: false, text: 'Ações', value: 'actions', align: 'center', width: '30%' }
            ],
            escopos: ['read', 'write', 'trust'],
            grant_types: ['authorization_code','password','refresh_token','implicit','client_credentials'],
            items: [],
            credential: {},
            index_client_secret: 0,
            dialog_role: null,
            client_id: '',
            product_id: ''
        }),
        components: {
            RoleCredentials
        },
        computed: {
            ...mapState('product', ['products']),
            ...mapState('permission', ['permissions']),
            ...mapGetters('product', ['get_product_name']),
            ...mapGetters('app', ['hasRole']),
            title() { return 'Credenciais da Organização: '+ this.organization.name },
            dialog: {
                get() { return this.value },
                set(v) { this.$emit('input', v) }
            },
            label_btn_add() {
                return this.isEdit === true ? 'ALTERAR' : 'ADICIONAR'
            },
            icon_btn_add() {
                return this.isEdit === true ? 'mdi-pencil-outline' : 'mdi-plus-circle-outline'
            },
            products_filtred() {
                var list = []
                var context = this
                this.products.forEach(p => {
                    if (context.items.filter(i => i.product_id == p.id).length == 0) {
                        list.push(p)
                    }
                })

                return list
            },
            permissions_product() {
                var context = this
                if (context.product_id) {
                    var permissions_filtred = []
                    
                    var permissions = context.permissions.filter(r => r.product_id == context.product_id)
                    permissions.forEach(r => {
                        if (context.items.filter(i => i.permission_id == r.id).length == 0) {
                            permissions_filtred.push(r)
                        }
                    });

                    return permissions_filtred
                }
                return []
            },
            showPassword() {
                return !this.isEdit || this.is_new_client_secret
            },
            client_secret() { 
                if (this.index_client_secret >= 0) {
                    if (this.credential.client_secret) {
                        return this.credential.client_secret
                    }
                    if (this.credential.client_id) {
                        return this.cryptoRandomString({ length: 16 })
                    }
                }
                return null
            },
            escopo: {
                get() { 
                    if (this.credential.scope) {
                        return this.credential.scope.split(',') 
                    }
                    return []
                },
                set(val) {
                    this.credential.scope = val.join(',')
                }
            },
            authorized_grant_types: {
                get() { 
                    if (this.credential.authorized_grant_types) {
                        return this.credential.authorized_grant_types.split(',') 
                    }
                    return []
                },
                set(val) {
                    this.credential.authorized_grant_types = val.join(',')
                }
            }
        },
        mounted() {
            this.search(this.organization)
        },
        methods: {
            required,
            cryptoRandomString: cryptoRandomString,
            add() {
                if (this.$refs.form.validate()) {
                    this.credential.organization_id = this.organization.id
                    var credentials = Object.assign({}, this.credential)
                    
                    if (!this.isEdit) {
                        credentials.is_new = true
                        this.items.push(credentials)
                    }
                    else {
                        for (var i = 0; i < this.items.length; i++) {
                            if (this.items[i].client_id == credentials.client_id) {
                                this.items[i] = Object.assign({}, credentials)
                            }
                        }
                    }

                    this.isEdit = false
                    this.$refs.form.reset()
                }
            },
            remove({ client_id }) {
                var index = false
                for (var i = 0; i < this.items.length; i++) {
                    if (index === false) {
                        if (this.items[i].client_id == client_id) {
                            index = i
                        }
                    }
                }
                this.items.splice(index, 1)
            },
            async save() {
                this.loading = true
                try {
                    await this.axios.post(this.$store.state.url_api + '/organization/' + this.organization.id +'/credentials', this.items)
                    this.search(this.organization)
                }
                finally {
                    this.loading = false
                }
            },
            update(item) {
                this.credential = Object.assign({}, item)
                this.is_new_client_secret = false
                this.isEdit = true
            },
            search({ id }) {
                if (!id) return ;
                var context = this
                context.loading = true
                this.axios.get(this.$store.state.url_api + '/organization/' + context.organization.id +'/credentials')
                    .then(r => context.items = r.data)
                    .finally(() => context.loading = false)
            },
            cancel() {
                this.$refs.form.reset()
                this.isEdit = false
            },
            close() {
                this.dialog = false
                this.$refs.form.reset()
                this.$emit('clear')
            },
            roles({ client_id, product_id }) {
                this.dialog_role = true
                this.client_id = client_id
                this.product_id = product_id
            },
            generate_client_id() {
                var context = this
                context.loading_client_id = true

                this.axios.get(this.$store.state.url_api + '/organization/' + context.organization.id +'/generate-client-id')
                    .then(r => context.credential.client_id = r.data)
                    .finally(() => context.loading_client_id = false)
            },
            generate_client_secret() {
                var context = this
                context.loading_client_secret = true
                
                this.axios.get(this.$store.state.url_api + '/organization/' + context.organization.id +'/generate-client-secret')
                    .then(r => { 
                        context.credential.client_secret = r.data 
                        context.credential.is_new_client_secret = true
                        context.is_new_client_secret = true
                        context.index_client_secret++
                    })
                    .finally(() => context.loading_client_secret = false)
            }
        },
        props: {
            value: Boolean,
            organization: {
                type: Object,
                required: true
            }
        },
        watch: {
            organization(val) {
                this.search(val)
            }
        }
    }
</script>